import React from 'react';
import { dataHooks } from '@wix/data-hooks';
import { SectionNotification, SectionNotificationType } from 'wix-ui-tpa/cssVars';
import Error from 'wix-ui-icons-common/on-stage/Error';
import { SanitizeInnerHTMLWrapper } from '@wix/wixstores-client-common-components';
import { useDeliverySectionData } from '../../../provider/useDeliverySectionContext';
import { classes } from './Violations.st.css';
export const ViolationsHooks = dataHooks('Violations');
export const Violations = () => {
  const {
    violations
  } = useDeliverySectionData();
  if (!(violations != null && violations.length)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": ViolationsHooks.root()
  }, violations.map((violation, index) => /*#__PURE__*/React.createElement(SectionNotification, {
    key: `${violation}-${index}`,
    type: SectionNotificationType.error,
    "data-hook": ViolationsHooks.sectionNotification({
      index
    }),
    className: classes.violation
  }, /*#__PURE__*/React.createElement(SectionNotification.Icon, {
    icon: /*#__PURE__*/React.createElement(Error, {
      className: classes.errorIcon
    })
  }), /*#__PURE__*/React.createElement(SectionNotification.Text, null, /*#__PURE__*/React.createElement(SanitizeInnerHTMLWrapper, {
    innerHtml: violation
  }, /*#__PURE__*/React.createElement("div", {
    "data-hook": ViolationsHooks.message({
      index
    })
  }))))));
};
//# sourceMappingURL=Violations.js.map